<template>
    <div class="page">
        <el-form ref="form" :model="attributeWholeList" label-width="70px">
            <el-tabs type="border-card">
                <el-tab-pane label="基本信息">
                    <information-edit ref="form1" @change="changeCategoryId" @getSpuList="getBrandName"></information-edit>
                </el-tab-pane>
                <el-tab-pane label="商品相册">
                    <el-form-item label="商品相册" prop="productAlbum">
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                            :disabled="stateDisabled"
                        >
                            <el-button size="small" :disabled="stateDisabled" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                        </el-upload>
                    </el-form-item>
<!--                    <el-form-item label="商品视频" prop="productAlbum">-->
<!--                        <el-upload-->
<!--                            class="uploadAlbum"-->
<!--                            action=""-->
<!--                            :file-list="videoFileList"-->
<!--                            :before-upload="handleBeforeUpload"-->
<!--                            :on-remove="handleVodRemove"-->
<!--                            :http-request="uploadAvatar"-->
<!--                            :on-success="onSucc"-->
<!--                            list-type="picture"-->
<!--                            :limit="1"-->
<!--                        >-->
<!--                            <el-button size="small" type="primary">点击上传</el-button>-->
<!--                            <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过50mb</div>-->
<!--                        </el-upload>-->
<!--                    </el-form-item>-->
                </el-tab-pane>
                <el-tab-pane label="商品描述">
<!--                    <el-form-item label="商品简介" prop="saleStatement">-->
<!--                        <el-input-->
<!--                            type="textarea"-->
<!--                            style="width: 800px"-->
<!--                            :disabled="stateDisabled"-->
<!--                            size="small"-->
<!--                            :rows="3"-->
<!--                            v-model="attributeWholeList.saleStatement"-->
<!--                        ></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="商品详情" prop="productContent">
                        <WangEditor ref="contentEditor" :disabled="stateDisabled" v-model="attributeWholeList.detail" />
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品属性">
                    <spu-edit ref="form2"></spu-edit>
                </el-tab-pane>
                <el-tab-pane label="商品规格">
                    <sku-edit ref="form3"></sku-edit>
                </el-tab-pane>

            </el-tabs>
        </el-form>
    </div>
</template>

<script>
import skuEdit from '../huicaiyun/skuEdit.vue';
import InformationEdit from '../huicaiyun/InformationEdit.vue';
import spuEdit from '../huicaiyun/spuEdit.vue';

import WangEditor from '@/components/common/wangeditor';
import { get, post, postJson, upload } from '@/utils/request.js';
import eventBus from '../../api/eventBus';
import { UPLOAD_API,UPLOAD_PATH } from '@/utils/constant.js';

export default {
    components: {
        InformationEdit,
        spuEdit,
        skuEdit,
        WangEditor
    },
    props: {
        shopProduct: {
            type: Object,
            default: {}
        },
        shopProductState: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            attributeWholeList: {
                detail: '',
                imageList: '',
            },
            albumList: '',
            isScoreList: [
                {
                    value: 0,
                    label: '否'
                },
                {
                    value: 1,
                    label: '是'
                }
            ],
            header: {
                token: localStorage.getItem('token')
            },
            fileList: [],
            videoFileList: [],

            temporaryList: [],
            stateDisabled: false,
            action: UPLOAD_API + UPLOAD_PATH,
            fileType: ['mp4'],
            // 上传文件大小限制(MB)
            fileSize: '50'
        };
    },
    created() {
    },
    watch: {
        // 监听分类id
        shopProduct: {
            handler(newVal, oldVal) {
                if (Object.keys(newVal).length != 0) {
                    this.attributeWholeList = { ...this.attributeWholeList, ...newVal };

                    this.$refs.contentEditor.init(this.attributeWholeList.detail);
                    eventBus.$emit('shopProduct', this.attributeWholeList, this.shopProductState);
                    this.fileList = [];

                    if (this.attributeWholeList.imageList) {
                        let list = this.attributeWholeList.imageList;

                        this.fileList = list.map((item) => {
                            return {
                                name: item,
                                url: item
                            };
                        });
                        this.temporaryList = [];
                        for (let item of list) {
                            this.temporaryList.push(item);
                        }
                        this.albumList = '';
                        this.albumList = this.temporaryList;
                    }

                    if(this.attributeWholeList.categoryId){
                        this.dataSeperator()
                    }
                    if (this.attributeWholeList.spuList != null) {
                        eventBus.$emit('spuList', this.attributeWholeList.spuList, this.shopProductState);
                    }
                    if (this.attributeWholeList.skuList != null || this.attributeWholeList.skuValueList != null) {
                        eventBus.$emit(
                            'skuList',
                            this.attributeWholeList.skuList,
                            this.attributeWholeList.skuValueList,
                            this.shopProductState
                        );
                    }
                }
            },
            immediate: true,
            deep: true
        },
        shopProductState: {
            handler(newVal, oldVal) {
                if (newVal == 'check') {
                    this.stateDisabled = true;
                } else {
                    this.stateDisabled = false;
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        //分出协议基础sku spu
        dataSeperator(){

            const categoryIdList = this.attributeWholeList.categoryId.split('|')
            get('/huicaiyun/huicaiyunproduct/getCategoryAtribute',{categoryId:categoryIdList[categoryIdList.length-1]})
                .then((res)=>{
                    if(res.success){
                        // 存spu的协议属性和基础属性
                        let spuList = {
                            agreement:[],
                            base:[],
                        }

                        // 存sku的协议属性和基础属性
                        let skuList = {
                            agreement:[],
                            agreementValueList:[],
                            base:[],
                            baseValueList:[],
                        }

                        // 协议属性
                        if(res.agreementAttr){
                            res.agreementAttr.forEach((item)=>{

                                // 分出spu和sku
                                if(item.attrMetas.isSkuCandidate){
                                    skuList.agreement.push({

                                    })
                                } else {
                                    spuList.agreement.push({

                                    })
                                }

                            })
                        }

                        // 基础属性
                        if(res.baseAttr){

                            res.baseAttr.forEach((item)=>{

                                // 分出spu和sku
                                if(item.attrMetas.isSkuCandidate){
                                    skuList.base.push({
                                        id:'',
                                        nameKvId:'',
                                        productId:'',
                                        nameKv:{
                                            kvId: '',
                                            kvName: item.attrName,
                                        },
                                        valueKvIds:'',
                                        valueKvList:item.attrVals.map((it)=>{
                                            return {
                                                kvId:'',
                                                kvName:it
                                            }
                                        }),
                                    })

                                } else {

                                    // 这里去判断spu里面有没有可下拉的数据
                                    let valueKvList
                                    if(Array.isArray(item.attrVals) && item.attrVals.length > 0){
                                        valueKvList = item.attrVals.map((it)=>{
                                            return {
                                                kvId:'',
                                                kvName:it,
                                            }
                                        })
                                    }else {
                                        valueKvList = null
                                        item.attrMetas.valueType = 2
                                    }

                                    spuList.base.push({
                                        id:'',
                                        isRequired: item.attrMetas.isRequired,
                                        nameKv:{
                                            kvId:'',
                                            kvName: item.attrName,
                                        },
                                        nameKvId:'',
                                        productId:'',
                                        spuValue:{
                                            id:'',
                                            spuName:item.attrName,
                                            spuId:'',
                                            value:'',
                                        },
                                        valueKvIds:'',
                                        valueKvList: valueKvList,
                                        valueType: item.attrMetas.valueType,
                                    })
                                }
                            })
                        }

                        let categoryId = this.shopProduct.categoryId.split('|')[2]

                        eventBus.$emit('pushSpuList',spuList,categoryId);
                        eventBus.$emit('pushSkuList',skuList);

                    }
                })
        },

        // 获取品牌型号
        getBrandName(id,name){
           eventBus.$emit('brandName',name)
        },


        // 删除图片
        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (!file.response) {
                    if (file.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                } else {
                    if (file.response.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                }
            }
            this.albumList = this.temporaryList;
        },
        //上传成功
        handleSuccess(response, file, fileList) {
            // this.temporaryList = [];
            this.temporaryList.push(file.response.url);
            this.albumList = this.temporaryList;
        },
        //上传图片限制
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        changeCategoryId(id) {
            this.shopProduct.categoryId = id
        },

        // 生成唯一Id
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },

        // 关闭
        closeDialog() {
            this.$refs.form1.clear();
            this.$refs.form3.tableData = [];
            this.$refs.form3.skuList = [];
            this.$refs.form2.attributeForm.attributeList = [];
        },
        //上传视频
        uploadAvatar(params) {
            const file = params.file;
            // let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            // if (!types.includes(file.type)) {
            //     this.$message.error('图片类型错误!');
            // }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.attributeWholeList.productVideo = res.url;
                }
            });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            if (this.attributeWholeList.productVideo != '' && this.attributeWholeList.productVideo != null) {
                this.$message({
                    message: '最多上传一个视频',
                    type: 'info',
                    duration: 2000
                });
                return false;
            }
            // 校检文件类型
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk && file) {
                    this.$message({
                        message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            // 校检文件大小;
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message({
                        message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }

            return true;
        },
        handleVodRemove(file, fileList) {
            if (fileList.length == 0) {
                this.attributeWholeList.productVideo = '';
                this.videoFileList = [];
            }
        },
        // 推送
        push(){
            // return;
            if (!this.$refs.form1.validateForm()) {
                this.$message({
                    message: '基本信息页没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            if (!this.$refs.form2.validateForm()) {
                this.$message({
                    message: '商品属性没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            let spuList = [];
            let spuValueList = [];
            let skuList = [];
            let skuValueList = [];

            let arr1 = this.$refs.form2.attributeForm.attributeList;
            let arr2 = this.$refs.form3.tableData;

            skuList = this.$refs.form3.skuList;

            for (let item of arr1) {
                // let id = this.guid();
                // let reg = new RegExp('-', 'g');
                // id = id.replace(reg, '');
                spuList.push({
                    id: item.id,
                    isRequired: item.isRequired,
                    nameKvId: item.nameKvId,
                    valueKvIds: item.valueKvIds,
                    valueType: item.valueType,
                    spuValue: {
                        id: item.spuValue.id,
                        spuName:item.spuValue.spuName,
                        spuId: item.id,
                        value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                    }
                });
                // spuValueList.push({
                //     id: item.spuValue.id,
                //     spuId: item.id,
                //     value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                // });
            }

            // return;
            for (let item of arr2) {
                skuValueList.push({
                    id: item.id,
                    skuKvIds: item.skuKvIds,
                    skuKvNames: item.skuKvNames,
                    skuCategory:item.skuCategory,
                    price: item.price,
                    stock: item.stock,
                    pic: item.pic
                });
            }

            this.attributeWholeList.imageList = this.albumList;

            let product = this.$refs.form1.shopProduct;
            delete product.imageList
            delete product.detail

            let shopProduct = {
                ...this.attributeWholeList,
                ...product,
                spuList: spuList,
                spuValueList: spuValueList,
                skuList: skuList,
                skuValueList: skuValueList
            };
            console.log('原修改提交格式：；',shopProduct);
            // 处理电商平台链接
            let selfPlatformLink
            shopProduct.spuList.forEach((item)=>{
                if(item.spuValue.spuName == "电商平台链接"){
                    selfPlatformLink = item.spuValue.value
                }
            })

            let pushProduct = {
                id:null,
                productId:shopProduct.productId,
                itemCode:shopProduct.itemCode,
                productName:shopProduct.productName,
                categoryId:shopProduct.categoryId,
                mainImage:shopProduct.mainImage,
                itemUnit:null,
                imageList:shopProduct.imageList,
                baseAttributeList:shopProduct.spuList.map((item)=>{
                    return {
                        attrKey: item.spuValue.spuName,
                        attrValList: [item.spuValue.value]
                    }
                }),
                skuPriceList:shopProduct.skuValueList.map((item)=>{
                    return{
                        skuCode: item.id,
                        marketPrice: item.price,
                        salePrice: item.price
                    }
                }),
                skuList:shopProduct.skuValueList.map((item)=>{
                    const skuKvName = item.skuKvNames.split(',')
                    const skuCategory = item.skuCategory.split(',')

                    return{
                        quantity: +item.stock,
                        skuCode: item.id,
                        attrs: skuKvName.map((it,index)=>{
                            return {
                                value:it,
                                key:skuCategory[index]
                            }
                        })
                    }
                }),
                selfPlatformLink: selfPlatformLink,
                origin:null,
                detail:shopProduct.detail,
                saleSpecImages:null,
                brandId:shopProduct.brandId,
                brandName:shopProduct.brandName,
            }

            console.log('推送提交格式：',pushProduct);
            postJson('/huicaiyun/huicaiyunproduct/pushProduct', { ...pushProduct }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    //this.$emit('closeDialog', true);
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                    //this.$emit('closeDialog', true);
                }
            });
        },

        // 提交修改
        submitForm() {
            // return;
            if (!this.$refs.form1.validateForm()) {
                this.$message({
                    message: '基本信息页没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            if (!this.$refs.form2.validateForm()) {
                this.$message({
                    message: '商品属性没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            let spuList = [];
            let spuValueList = [];
            let skuList = [];
            let skuValueList = [];

            let arr1 = this.$refs.form2.attributeForm.attributeList;
            let arr2 = this.$refs.form3.tableData;
            skuList = this.$refs.form3.skuList;

            for (let item of arr1) {
                // let id = this.guid();
                // let reg = new RegExp('-', 'g');
                // id = id.replace(reg, '');
                spuList.push({
                    id: item.id,
                    isRequired: item.isRequired,
                    nameKvId: item.nameKvId,
                    valueKvIds: item.valueKvIds,
                    valueType: item.valueType,
                    spuValue: {
                        id: item.spuValue.id,
                        spuId: item.id,
                        value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                    }
                });
                // spuValueList.push({
                //     id: item.spuValue.id,
                //     spuId: item.id,
                //     value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                // });
            }

            // return;
            for (let item of arr2) {
                skuValueList.push({
                    id: item.id,
                    skuKvIds: item.skuKvIds,
                    price: item.price,
                    stock: item.stock,
                    pic: item.pic
                });
            }

            this.attributeWholeList.productAlbum = this.albumList;

            let product = this.$refs.form1.shopProduct;

            delete product.productContent;
            delete product.productAlbum;

            // 商品不为积分商品时清楚所需积分
            if(product.productType!=2){
                product.productScore = 0
            }

            let shopProduct = {
                ...this.attributeWholeList,
                ...product,
                productVideo: this.attributeWholeList.productVideo,
                spuList: spuList,
                spuValueList: spuValueList,
                skuList: skuList,
                skuValueList: skuValueList
            };
            console.log('this.attributeWholeList',this.attributeWholeList);
            return;
            postJson('/shop/product/edit', { ...shopProduct }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.$emit('closeDialog', true);
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                    this.$emit('closeDialog', true);
                }
            });
            this.closeDialog();
        },
        onSucc(response, file, fileList) {
        }
    }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     width: 200px;
//     height: 200px;
// }
</style>
